import { Component, OnInit } from '@angular/core';
import { GetMeNotifiedService } from '@shared/services';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { EMAIL } from '@shared/constants/email.ts';
import { CONVERTKIT } from '@env/environment';

const API_KEY = CONVERTKIT.API_KEY;
const FORM_ID = CONVERTKIT.SIGNUP_FORM_ID;
declare const fbq: any;

@Component({
  selector: 'get-me-notified',
  templateUrl: './get-me-notified.component.html',
  styleUrls: ['./get-me-notified.component.scss']
})
export class GetMeNotifiedComponent implements OnInit {
  formNotified: FormGroup;
  isPreOrder;

  constructor(
    private fb: FormBuilder,
    private _getMeNotified: GetMeNotifiedService
  ) {
    this.formNotified = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(EMAIL.EMAIL_REGEX)]],
      isAccredited: ['', Validators.required]
    });
  }

  ngOnInit() {
    this._getMeNotified.isPreOrder.subscribe(isPreOrder => {
      this.isPreOrder = isPreOrder;
    });
  }

  submitSubscriptions() {
    if (this.formNotified.invalid) {
      return;
    }
    const postData = {
      api_key: API_KEY,
      email: this.formNotified.value.email,
      fields: {
        are_you_an_accredited_investor: this.formNotified.value.isAccredited
      }
    };
    this._getMeNotified.addSubscriber(postData, FORM_ID).subscribe(() => {
      this._getMeNotified.toggle();
    });
  }

  get controls() {
    return this.formNotified.controls;
  }

  close() {
    this._getMeNotified.toggle();
  }
}
